module.exports = __webpack_public_path__ + "img/Marquee_Logo.ad6e3603.png";